import api from 'api';
import type {
  InvoiceCreationResponse,
  InvoicePreviewCreationResponse,
  InvoiceRequestBody,
  InvoiceRequestParams,
  RawInvoice,
  RawInvoiceRules,
  UpdateInvoiceRulesRequest,
} from 'types/invoice';
import { encodeUrlParams } from 'utils/url-params';

export const invoicesApi = {
  getInvoiceRules(): Promise<RawInvoiceRules> {
    return api.get('invoices/rules');
  },
  updateInvoiceRules(request: UpdateInvoiceRulesRequest): Promise<RawInvoiceRules> {
    return api.put('invoices/rules', { invoice_rules: request });
  },
  getInvoices(parameters?: Partial<InvoiceRequestParams>): Promise<Array<RawInvoice>> {
    const baseParameters = {
      order: 'desc',
      limit: 50,
      offset: 0,
      ...parameters,
    };

    return api.get(`invoices${encodeUrlParams(baseParameters)}`);
  },
  getInvoiceById(id: number): Promise<RawInvoice> {
    return api.get(`invoices/${id}`);
  },
  createInvoice(invoice: InvoiceRequestBody): Promise<InvoiceCreationResponse> {
    return api.post('invoices', {
      invoice,
    });
  },
  createInvoicePreview(invoice: InvoiceRequestBody): Promise<InvoicePreviewCreationResponse> {
    return api.post('invoices/preview', {
      invoice,
    });
  },
  // possibly need new type for this, `name` is required here according to docs
  // come back after testing
  // Possibly moot point, may not be exposing this endpoint on client side
  updateInvoice(invoice: Partial<InvoiceRequestBody>): Promise<RawInvoice> {
    return api.put('invoices', {
      invoice,
    });
  },
  deleteInvoiceById(id: number): Promise<void> {
    return api.delete(`invoices/${id}`);
  },
  syncInvoiceToDefaultApp(invoiceId: number) {
    return api.put(`invoices/${invoiceId}/sync`);
  },
  syncInvoiceToApp(connectionId: number, invoiceId: number) {
    return api.put(`apps/${connectionId}/invoices/${invoiceId}`);
  },
};
